import { render } from "./EventList.vue?vue&type=template&id=336ec38a"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"
script.render = render

export default script